import { BasicAttributes } from './sections/BasicAttributes'
import { BulkManagement } from './sections/BulkManagement'

export const WorkspaceForm = (): JSX.Element => {
  return (
    <>
      <BasicAttributes />
      <BulkManagement />
    </>
  )
}
